import React, { useState, useRef, useEffect } from "react";

const EditInput = (props) => {
  const { inputValue, onInputChange, onEditCompleted, editorPosition } = props;
  const inputRef = useRef(null);

  function resize() {
    if (inputRef.current) {
      const outerHeight = inputRef.current
        .getBoundingClientRect()
        .height.toFixed(0);
      const height =
        outerHeight -
        inputRef.current.clientHeight +
        inputRef.current.scrollHeight;

      inputRef.current.height = "auto";
      inputRef.current.style.height = height + "px";

      console.log("height", height);
    }
  }

  useEffect(() => {
    resize();
  }, [inputValue, onInputChange]);

  if (
    !props.hasOwnProperty("inputValue") ||
    !props.hasOwnProperty("onInputChange")
  )
    throw new Error("EditInput requires value and onChange in props");

  useEffect(() => {
    const ref = inputRef.current;

    function delayedResize() {
      setTimeout(resize, 0);
    }

    if (ref) {
      ref.addEventListener("input", resize, true);
      ref.addEventListener("cut", delayedResize);
      ref.addEventListener("paste", delayedResize);
      ref.addEventListener("drop", delayedResize);
      ref.addEventListener("keydown", delayedResize);
      resize();
      ref.select();
      ref.focus();
    }

    return () => {
      if (ref) {
        ref.removeEventListener("input", resize, true);
        ref.removeEventListener("cut", delayedResize);
        ref.removeEventListener("paste", delayedResize);
        ref.removeEventListener("drop", delayedResize);
        ref.removeEventListener("keydown", delayedResize);
      }
    };
  }, []);

  const onValueChange = (evt) => {
    //TODO: best place to maintain other housekeeping things here.
    onInputChange(evt.target.value);
  };

  const onKeyPress = (evt) => {
    if (evt.key === "Enter" && evt.shiftKey) {
      // setEditMode(false);
      //   if (titleRef.current) {
      //     titleRef.current.width = inputRef.current.width + "px";
      //   }
      if (onEditCompleted) onEditCompleted(evt.target.value);
    }
  };

  return (
    <div className="title__editview">
      <textarea
        spellCheck={true}
        ref={inputRef}
        onKeyPress={onKeyPress}
        onChange={onValueChange}
        value={inputValue}
      ></textarea>
    </div>
  );
};

export default EditInput;
